/**
 * Dynamically loads a script by adding a `script` element to the document head
 * @param src the script source
 * @returns a function to remove the script
 */
export function addScript(src: string): () => void {
  const script = document.createElement('script');
  script.src = src;
  script.async = false;
  document.head.appendChild(script);
  return () => {
    document.head.removeChild(script);
  };
}

export function handleKeyboardClick(e: React.KeyboardEvent) {
  if (e.key === ' ' || e.key === 'Enter') {
    if (typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    (e.currentTarget as HTMLElement).click();
  }
}

export function handleEnterOrSpacePress(
  e: React.KeyboardEvent,
  action?: () => void,
) {
  if (e.key === ' ' || e.key === 'Enter') {
    if (typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    if (action) action();
  }
}

// utility function to remove comma from given string
export function removeCommas(str: string) {
  return str.replace(/,/g, '');
}
